import { useContext, useMemo } from "react";
import Valve from "../components/Valve";
import Transmitter4 from "../components/Transmitter4";
import Transmitter from "../components/Transmitter";
import "./ThirdStageSeparator.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";

import { trackPageVisit } from "../competency/PageTracker";



 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }





function ThirdStageSeparator() {

      useEffect(() => {
  
    trackPageVisit("ThirdStageSeparator");
  
  }, []);

  const {  valves, toggleValve, transmitters} = useContext(WellContext);

  const { levels } = useContext(WellContext);
  // ================= LEVEL FLOW LOGIC =================

     

  const DEFAULT_VALVES = {
  FCV_15001: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_15002: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_15003: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_15004: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_15005: { mode: "Manual", opening: 0, sp: "", pv: "" },
};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("ThirdStageSeparator_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_15001: { ...DEFAULT_VALVES.FCV_13001, ...parsed.FCV_15001 },
      FCV_15002: { ...DEFAULT_VALVES.FCV_13003, ...parsed.FCV_15002 },
      FCV_15003: { ...DEFAULT_VALVES.FCV_13005, ...parsed.FCV_15003 },
      FCV_15004: { ...DEFAULT_VALVES.FCV_13006, ...parsed.FCV_15004 },
      FCV_15005: { ...DEFAULT_VALVES.FCV_13006, ...parsed.FCV_15005 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("ThirdStageSeparator_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };




    const [TT_14007a, setTT_14007a] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_14007a")) || 0;
            setTT_14007a(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);


  const isXV_15001Open = valves?.XV_15001 === false;


          // ================= CRUDE FLOW from SECOND STAGE SEPARATOR to THIRD STAGE SEPARATOR =================
              const [FIC_15001, setFIC_15001] = useState(() => {
                return Number(localStorage.getItem("FIC_15001")) || 0;
              });   
              const targetFIC_15001 = useMemo(() => {
                const fic = Number(transmitters?.FIC_14007 ?? 0);
                return valves?.XV_15001 === false ? fic : 0.03;
              }, [transmitters?.FIC_14007, valves?.XV_15001]);
        
              useEffect(() => {
                const interval = setInterval(() => {
                  setFIC_15001(prev => {
                    const diff = targetFIC_15001 - prev;
        
                    // smoothing factor (tune this)
                    const step = diff * 0.08;
        
                    // snap when very small difference
                    if (Math.abs(diff) < 0.001) return targetFIC_15001;
        
                    return prev + step;
                  });
                }, 200); // update speed
        
                return () => clearInterval(interval);
              }, [targetFIC_15001]);
        
              useEffect(() => {
                    localStorage.setItem("FIC_15001", FIC_15001);
                  }, [FIC_15001]);


               
    
// ================= CRUDE FLOW from TEST HEADER to THIRD STAGE SEPARATOR =================
              const [FIC_15009, setFIC_15009] = useState(() => {
                return Number(localStorage.getItem("FIC_15009")) || 0;
              });   
              const targetFIC_15009 = useMemo(() => {
                const fic = Number(transmitters?.FIC_13008 ?? 0);
                return valves?.XV_15001 === false ? fic : 0.03;
              }, [transmitters?.FIC_13008, valves?.XV_15001]);
        
              useEffect(() => {
                const interval = setInterval(() => {
                  setFIC_15009(prev => {
                    const diff = targetFIC_15009 - prev;
        
                    // smoothing factor (tune this)
                    const step = diff * 0.08;
        
                    // snap when very small difference
                    if (Math.abs(diff) < 0.001) return targetFIC_15009;
        
                    return prev + step;
                  });
                }, 200); // update speed
        
                return () => clearInterval(interval);
              }, [targetFIC_15009]);
        
              useEffect(() => {
                    localStorage.setItem("FIC_15009", FIC_15009);
                  }, [FIC_15009]);
    

  // ================= CRUDE FLOW from SLUDGE CATCHER to THIRD STAGE SEPARATOR =================
              const [FIC_15010, setFIC_15010] = useState(() => {
                return Number(localStorage.getItem("FIC_15010")) || 0;
              });   
              const targetFIC_15010 = useMemo(() => {
                const fic = Number(transmitters?.FIC_2704 ?? 0);
                return valves?.XV_15001 === false ? fic : 0.03;
              }, [transmitters?.FIC_2704, valves?.XV_15001]);
        
              useEffect(() => {
                const interval = setInterval(() => {
                  setFIC_15010(prev => {
                    const diff = targetFIC_15010 - prev;
        
                    // smoothing factor (tune this)
                    const step = diff * 0.08;
        
                    // snap when very small difference
                    if (Math.abs(diff) < 0.001) return targetFIC_15010;
        
                    return prev + step;
                  });
                }, 200); // update speed
        
                return () => clearInterval(interval);
              }, [targetFIC_15010]);
        
              useEffect(() => {
                    localStorage.setItem("FIC_15010", FIC_15010);
                  }, [FIC_15010]);
    






        const inflows5 = (isXV_15001Open && FIC_15001 > 0)
        ? [(FIC_15001 + FIC_15009 + FIC_15010) / 60]
        : [];          

       const waterFlow = (FIC_15001 + FIC_15009 + FIC_15010) * 0.03 * 159.987 || 0;
       const inflows6 = (isXV_15001Open && waterFlow > 0)
        ? [waterFlow / 60]
        : [];

                  
      const FIC_15002 = isXV_15001Open ? ((FIC_15001 + FIC_15009 + FIC_15010) * 0.04 * 5.615) : 0;

      
           // First flow (direct from FCV)
        const targetFIC_15008 = isXV_15001Open
        ? FIC_15002 * ((valveData?.FCV_15001?.opening || 0) / 100)
        : 0;

         const [FIC_15008, setFIC_15008] = useState(() => {
        return Number(localStorage.getItem("FIC_15008")) || 0;
      }); 

    useEffect(() => {
        const interval = setInterval(() => {
          setFIC_15008(prev => {
            const diff = targetFIC_15008 - prev;

            // smoothing factor (tune this)
            const step = diff * 0.1;

            // snap when very close
            if (Math.abs(diff) < 0.001) return targetFIC_15008;

            return prev + step;
          });
        }, 200); // speed of update

        return () => clearInterval(interval);
      }, [targetFIC_15008]);

      useEffect(() => {
            localStorage.setItem("FIC_15008", FIC_15008);
          }, [FIC_15008]);


      const FIC_15003 = ((valveData?.FCV_15002?.opening || 0) / 100) * Number(transmitters?.FIC_13004 ?? 0);
       const PT_15003 = ((valveData?.FCV_15002?.opening || 0) / 100) * Number(transmitters?.PT_13004 ?? 0);

             useEffect(() => {
            localStorage.setItem("FIC_15003", FIC_15003);
          }, [FIC_15003]);

             useEffect(() => {
            localStorage.setItem("PT_15003", PT_15003);
          }, [PT_15003]);







           // Remaining gas after first split
        const FIC_15004 = (FIC_15002 - FIC_15008) + FIC_15002;

          const { setTransmitters } = useContext(WellContext);
          useEffect(() => {
              setTransmitters(prev => ({
                ...prev,
                FIC_15004: FIC_15004
              }));
            }, [FIC_15004, setTransmitters]);



            
            const TT_15001 = isXV_15001Open ? TT_14007a : 22;
        
       
        


                  
            const [PT_15001, setPT_15001] = useState(() => {
                return Number(localStorage.getItem("PT_15001")) || 0;
              });   
              const targetPT_15001 = useMemo(() => {
                const fic = Number(transmitters?.PT_14002 ?? 0);
                return valves?.XV_15001 === false ? fic : 0.03;
              }, [transmitters?.PT_14002, valves?.XV_15001]);
        
              useEffect(() => {
                const interval = setInterval(() => {
                  setPT_15001(prev => {
                    const diff = targetPT_15001 - prev;
        
                    // smoothing factor (tune this)
                    const step = diff * 0.08;
        
                    // snap when very small difference
                    if (Math.abs(diff) < 0.001) return targetPT_15001;
        
                    return prev + step;
                  });
                }, 200); // update speed
        
                return () => clearInterval(interval);
              }, [targetPT_15001]);
        

            
            const TT_15002 = isXV_15001Open ? TT_15001 - (TT_15001 * 0.023) : 22;
            const PT_15002 = isXV_15001Open ? PT_15001 - (PT_15001 * 0.0053) : 0.03;


          useEffect(() => {
                localStorage.setItem("TT_15002", TT_15002);
              }, [TT_15002]);

              

          const TT_15004 = isXV_15001Open ? TT_15002 - (TT_15002 * 0.0098) : 0.003;
          const PT_15004 = isXV_15001Open ? PT_15002 - (PT_15002 * 0.0098) : 0.003;

             
  // ================= DECREMENTING IMPURITY LEVEL OF SECOND STAGE SEPARATOR CHAMBER =================
        const impurityFlowRateThirdStageSeparator = 250.675;
       const FIC_15005 = impurityFlowRateThirdStageSeparator * ((valveData?.FCV_15003?.opening || 0) / 100);


          useEffect(() => {
                localStorage.setItem("TT_15004", TT_15004);
              }, [TT_15004]);

          useEffect(() => {
                localStorage.setItem("PT_15004", PT_15004);
              }, [PT_15004]);
          useEffect(() => {
                localStorage.setItem("FIC_15004", FIC_15004);
              }, [FIC_15004]);
       
      
// =================  DECREMENTING CRUDE LEVEL OF FIRST STAGE SEPARATOR CHAMBER =================

      const isXV_15002Open = valves?.XV_15002 === false;

      const crudeFlowRateThirdStageSeparator = 300.56
       const FIC_15007 = isXV_15002Open ? crudeFlowRateThirdStageSeparator * 0.89 * ((valveData?.FCV_15005?.opening || 0) / 70): 0;

      const FIC_15007a = isXV_15002Open ? FIC_15007 * 24 : 0;
       const crudeDensity1 = 855.565;
      const FIC_15007b = isXV_15002Open ? (FIC_15007 / 1000 / 60) * crudeDensity1 : 0;

      const TT_15007a = isXV_15002Open ? 48 * 0.98 :22;

      const PT_15007a = isXV_15002Open ? 0.15 : 0;


      useEffect(() => {
        setTransmitters(prev => ({
          ...prev,
          FIC_15007: FIC_15007
        }));
      }, [FIC_15007]);

       // ================= DECREMENTING WATER LEVEL OF FIRST STAGE SEPARATOR CHAMBER =================

      const isXV_15003Open = valves?.XV_15003 === false;

      const waterFlowRateThirdStageSeparator = 29.942;
       const FIC_15006 = isXV_15003Open ? (waterFlowRateThirdStageSeparator * ((valveData?.FCV_15004?.opening || 0) / 100)) : 0;
       const FIC_15006a = isXV_15003Open ? FIC_15006 * 24 : 0;

       const waterDensity1 = 993.565;
      const FIC_15006b = isXV_15003Open ? (FIC_15006 / 1000 / 60) * waterDensity1 : 0;
       
      const TT_15006a = isXV_15003Open ? TT_15002 -(TT_15002 * 0.198) :22;

      
      useEffect(() => {
            setTransmitters(prev => ({
              ...prev,
              FIC_15006: FIC_15006
            }));
          }, [FIC_15006]);

        useEffect(() => {
            setTransmitters(prev => ({
              ...prev,
              TT_15006a: TT_15006a
            }));
          }, [TT_15006a]);



          useEffect(() => {
            setTransmitters(prev => ({
              ...prev,
              TT_15007a: TT_15007a
            }));
          }, [TT_15007a]);

          useEffect(() => {
            setTransmitters(prev => ({
              ...prev,
              PT_15007a: PT_15007a
            }));
          }, [PT_15007a]);



          useEffect(() => {
            setTransmitters(prev => ({
              ...prev,
              PT_15002: PT_15002
            }));
          }, [PT_15002]);
     


              /// ================= INFLOW INTO THIRD STAGE =================
                  const inflow_140 =
                    valves?.XV_12001 === false
                      ? ((FIC_15001 || 0) + (FIC_15009 || 0) + (FIC_15010 || 0)) / 5
                      : 0;

                  // ================= OUTFLOW FROM THIRD STAGE =================
                  const outflow_140 =
                    valves?.XV_15001 === false
                      ? (transmitters?.FIC_14007 || 0) / 60
                      : 0;




  return (
    <div className="ThirdStageSeparator-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "310px",
        color: "white",
        background: "rgba(39, 18, 233, 0.5)",
        padding: "2px 220px"
      }}>
        THIRD STAGE SEPARATOR
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-14001 */}
      <Valve
        className="XV-15001"
        tag="XV_15001"
        x={195}
        y={137}
        isClosed={valves.XV_15001}
        toggle={toggleValve}
      />

      {/* XV-15002 */}
      <Valve
        className="XV-15002"
        tag="XV_15002"
        x={545}
        y={417}
        isClosed={valves.XV_15002}
        toggle={toggleValve}
        r={90}
      />

      
      {/* XV-15003 */}
      <Valve
        className="XV-15003"
        tag="XV_15003"
        x={417}
        y={460}
        isClosed={valves.XV_15003}
        toggle={toggleValve}
        r={90}
      />


      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-15001 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-15001"
          style={{ position: "absolute", left: 717, top: 100, transform: "rotate(270deg)", transformOrigin: "center" }}  onClick={() => openPanel("FCV_15001")}>
          
          <defs>
            <linearGradient id="metal_15001">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_15001)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_15001)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>



        {/* FCV-15002 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-15002"
          style={{ position: "absolute", left: 828, top: 153 }}  onClick={() => openPanel("FCV_15002")}>
          
          <defs>
            <linearGradient id="metal_15002">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_15002)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_15002)" stroke="#7f8c8d" strokeWidth="2" />

          </svg>
        


        {/* FCV-15003 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-15003"
          style={{ position: "absolute", left: 219, top: 505}}  onClick={() => openPanel("FCV_15003")}>
          
          <defs>
            <linearGradient id="metal_15003">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_15003)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_15003)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


       
        {/* FCV-15004 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-15004"
          style={{ position: "absolute", left: 568, top: 680}}  onClick={() => openPanel("FCV_15004")}>
          
          <defs>
            <linearGradient id="metal_15004">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_15004)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_15004)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

      
        {/* FCV-15005 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-15005"
          style={{ position: "absolute", left: 888, top: 610}}  onClick={() => openPanel("FCV_15005")}>
          
          <defs>
            <linearGradient id="metal_15005">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_15005)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_15005)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

      
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_15001?.opening || 0)}
        x={774}
        y={114}
      />

      <ValveOutput
        value={Number(valveData?.FCV_15002?.opening || 0)}
        x={850}
        y={200}
      />
      <ValveOutput
        value={Number(valveData?.FCV_15003?.opening || 0)}
        x={242}
        y={544}
      />

      <ValveOutput
        value={Number(valveData?.FCV_15004?.opening || 0)}
        x={589}
        y={724}
      />

      <ValveOutput
        value={Number(valveData?.FCV_15005?.opening || 0)}
        x={913}
        y={654}
      />




      <Transmitter
      value={FIC_15009}
      x={85}
      y={235}
      unit="BPM"
      max={50}
      HH={45}
      H={40}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF CRUDE FROM TEST SEPARATOR OIL LINE"
      tag="FIC-15009"
    />
    
      <Transmitter
      value={FIC_15010}
      x={85}
      y={349}
      unit="BPM"
      max={50}
      HH={45}
      H={40}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF CRUDE FROM SLUDGE CATCHER UNIT"
      tag="FIC-15010"
    />

      <Transmitter
      value={FIC_15001}
      x={252}
      y={123}
      unit="BPM"
      max={300}
      HH={294}
      H={280}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF CRUDE FROM 2ND STAGE SEPARATOR"
      tag="FIC-15001"
    />

      <Transmitter
      value={FIC_15002}
      x={600}
      y={124}
      unit="SCF/S"
      max={100}
      HH={95}
      H={90}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF GAS AT GAS OUTLET OF 3RD STAGE SEPARATOR TO LP COMPRESSOR SUCTION COOLER"
      tag="FIC-15002"
    />

      <Transmitter
      value={FIC_15003}
      x={1028}
      y={124}
      unit="SCF/S"
      max={100}
      HH={95}
      H={90}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF GAS FROM TEST SEPARATOR"
      tag="FIC-15003"
    />

      <Transmitter
      value={FIC_15008}
      x={1151}
      y={85}
      unit="SCF/S"
      max={50}
      HH={45}
      H={40}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF GAS AT 3RD STAGE SEPARATOR PSV OUTLET LINE TO FLARE HEADER"
      tag="FIC-15008"
    />

    <Transmitter
      value={FIC_15004}
      x={935}
      y={490}
      unit="SCF/S"
      max={150}
      HH={145}
      H={140}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF GAS TO LP COMPRESSOR SUCTION COOLER"
      tag="FIC-15004"
     />

    <Transmitter
      value={FIC_15005}
      x={150}
      y={491}
      unit="LPM"
      max={20}
      HH={15}
      H={10}
      L={1}
      LL={0.1}
      c="lime"
      description="FLOWRATE OF WATER AND SEDIMENT TO CLOSE DRAIN FROM 3RD STAGE SEPARATOR"
      tag="FIC-15005"
     />


    <Transmitter
      value={PT_15003}
      x={940}
      y={124}
      unit="MPa"
      max={15}
      HH={14}
      H={10}
      L={0.3}
      LL={0.033}
      c="lime"
      description="PRESSURE OF GAS FROM TEST SEPARATOR"
      tag="PT-15003"
     />

    <Transmitter
      value={TT_15001}
      x={100}
      y={124}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="TEMPERATURE OF CRUDE FROM 2ND STAGE SEPARATOR TO INLET OF 3RD STAGE PRODUCTION SEPARATOR"
      tag="TT-15001"
     />

    <Transmitter
      value={TT_15002}
      x={433}
      y={158}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="TEMPERATURE OF GAS AT GAS OUTLET OF 3RD STAGE SEPARATOR TO LP COMPRESSOR SUCTION COOLER"
      tag="TT-15002"
     />
    <Transmitter
      value={PT_15001}
      x={345}
      y={158}
      unit="MPa"
      max={15}
      HH={14}
      H={10}
      L={0.3}
      LL={0.033}
      c="lime"
      description="PRESSURE OF 3RD STAGE SEPARATOR VESSEL"
      tag="PT-15001"
     />
    <Transmitter
      value={PT_15002}
      x={525}
      y={124}
      unit="MPa"
      max={15}
      HH={14}
      H={10}
      L={0.3}
      LL={0.033}
      c="lime"
      description="PRESSURE OF GAS AT GAS OUTLET OF 3RD STAGE SEPARATOR TO LP COMPRESSOR SUCTION COOLER"
      tag="PT-15002"
     />

     <Transmitter
      value={TT_15004}
      x={1092}
      y={490}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="TEMPERATURE OF GAS TO LP COMPRESSOR SUCTION COOLER"
      tag="TT-15004"
     />

     <Transmitter
      value={PT_15004}
      x={864}
      y={490}
      unit="MPa"
      max={15}
      HH={14}
      H={10}
      L={0.3}
      LL={0.033}
      c="lime"
      description="PRESSURE OF GAS TO LP COMPRESSOR SUCTION COOLER"
      tag="PT-15004"
     />

     <Transmitter
      value={FIC_15007}
      x={599}
      y={556}
      unit="BPM"
      max={300}
      HH={285}
      H={270}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF CRUDE FROM OUTLET OF 3RD STAGE SEPARATOR TO CRUDE DEHYDRATOR"
      tag="FIC-15007A"
    />

    <Transmitter
      value={FIC_15007a}
      x={599}
      y={566}
      unit="BPD"
      max={7750}
      HH={7745}
      H={7240}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF CRUDE FROM OUTLET OF 3RD STAGE SEPARATOR TO CRUDE DEHYDRATOR"
      tag="FIC-15007A"
    />
    <Transmitter
      value={FIC_15007b}
      x={599}
      y={576}
      unit="kg/m3"
      max={5}
      HH={4.23}
      H={3.8}
      L={0.05}
      LL={0.003}
      c="lime"
      description="FLOWRATE OF CRUDE FROM OUTLET OF 3RD STAGE SEPARATOR TO CRUDE DEHYDRATOR"
      tag="FIC-15007B"
    />
    <Transmitter
      value={TT_15007a}
      x={599}
      y={587}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="FLOWRATE OF CRUDE FROM OUTLET OF 3RD STAGE SEPARATOR TO CRUDE DEHYDRATOR"
      tag="TT-15007A"
    />
    <Transmitter
      value={PT_15007a}
      x={999}
      y={587}
      c="transparent"
    />

    <Transmitter
      value={FIC_15006}
      x={446}
      y={556}
      unit="LPM"
      max={200}
      HH={185}
      H={160}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF WATER FROM OUTLET OF 3RD STAGE SEPARATOR TO DE-OILER VESSEL"
      tag="FIC-15006"
    />
    <Transmitter
      value={FIC_15006a}
      x={446}
      y={566}
      unit="LPD"
      max={4000}
      HH={3885}
      H={3560}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF WATER FROM OUTLET OF 3RD STAGE SEPARATOR TO DE-OILER VESSEL"
      tag="FIC-15006A"
    />
    <Transmitter
      value={FIC_15006b}
      x={446}
      y={576}
      unit="kg/m3"
      max={5}
      HH={4}
      H={3}
      L={0.5}
      LL={0.03}
      c="lime"
      description="FLOWRATE OF WATER FROM OUTLET OF 3RD STAGE SEPARATOR TO DE-OILER VESSEL"
      tag="FIC-15006B"
    />
    <Transmitter
      value={TT_15006a}
      x={446}
      y={587}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="FLOWRATE OF WATER FROM OUTLET OF 3RD STAGE SEPARATOR TO DE-OILER VESSEL"
      tag="TT-15006A"
    />


    
      <LevelTransmitterIndicator
      tag="LT_15001"
      totalLevel={18000}
      inflows={[inflow_140]}
      outflows={[FIC_15007/4]}
      responseFactor={0.05}
      columnX={536}
      columnY={235}
      columnWidth={30}
      columnHeight={120}
      textX={627}
      textY={245}
      showFlow={true}
    />

      <LevelTransmitterIndicator
      tag="LT_15002"
      totalLevel={10000}
      inflows={inflows6}
      outflows={[FIC_15006]}
      responseFactor={0.05}
      columnX={410}
      columnY={300}
      columnWidth={30}
      columnHeight={120}
      textX={329}
      textY={373}
      showFlow={true}
    />





    </div>
  );
}

export default ThirdStageSeparator;